/**
 * Global Error Fallback Component
 * 
 * This component is displayed when an unhandled error occurs in the application.
 * It's used with Datadog's ErrorBoundary to provide a user-friendly error screen.
 */
export function GlobalErrorFallback({ 
  resetError, 
  error 
}: { 
  resetError: () => void; 
  error: Error;
}) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      padding: '20px',
      textAlign: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      backgroundColor: '#1a1a2e',
      color: '#e0e0e0',
    }}>
      <div style={{
        backgroundColor: '#252542',
        padding: '40px 60px',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        maxWidth: '500px',
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px',
        }}>
          ⚠️
        </div>
        <h1 style={{ 
          color: '#ff6b6b', 
          marginBottom: '16px',
          fontSize: '24px',
          fontWeight: 600,
        }}>
          Something went wrong
        </h1>
        <p style={{ 
          color: '#a0a0a0', 
          marginBottom: '24px',
          lineHeight: 1.6,
        }}>
          {error.message || 'An unexpected error occurred. Please try again.'}
        </p>
        <button
          onClick={resetError}
          style={{
            padding: '14px 32px',
            fontSize: '16px',
            backgroundColor: '#4facfe',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 500,
            transition: 'background-color 0.2s ease',
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#3b8cd9'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4facfe'}
        >
          Reload Application
        </button>
      </div>
    </div>
  );
}

